module.exports = __webpack_public_path__ + "static/img/12.bcd0b72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/zh/12.png
// module id = qoZk
// module chunks = 0